<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
      <div class="main-navbar">
        <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
          <a class="navbar-brand w-100 mr-0" href="#" style="line-height: 25px;">
            <div class="d-table m-auto">
              <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 110px;" src="@/assets/images/logo.jpg" alt="Logo">
            </div>
          </a>
          <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
            <i class="material-icons">&#xE5C4;</i>
          </a>
        </nav>
      </div>

      <form action="#" class="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none">
        <div class="input-group input-group-seamless ml-3">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="fas fa-search"></i>
            </div>
          </div>
          <input class="navbar-search form-control" type="text" placeholder="Search for something..." aria-label="Search">
        </div>
      </form>

      <div class="nav-wrapper">
          <d-nav class="flex-column">
            <li v-for="(item, navItemIdx) in filteredItems" :key="navItemIdx" class="nav-item dropdown">
              <d-link :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navItemIdx}`">
                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                <span v-if="item.title">{{ item.title }}</span>
                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
              </d-link>
              <d-collapse v-if="item.items && item.items.length" :id="`snc-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                <d-dropdown-item v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href" :to="subItem.to">
                  {{ subItem.title }}
                </d-dropdown-item>
              </d-collapse>
            </li>
          </d-nav>

          <user-data />
      </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'main-sidebar',
  props: {
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', [
      'userRole'
    ]),
    filteredItems () {
      return this.items.filter(item => !item.permissions || (item.permissions.indexOf(this.userRole) > -1));
    }
  },
  data() {
    return {
      sidebarVisible: false,
    };
  },
  created() {
    this.$bus.on('toggle-sidebar', this.handleToggleSidebar);
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    }
  },
  beforeUnmount() {
    this.$bus.off('toggle-sidebar');
  }
};
</script>

<style lang="scss">
  .main-sidebar {
    min-width: 220px;

    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }

    .navbar {
      height: auto;
    }

    .navbar-brand {
      height: 200px;
      width: 200px;
    }

    .nav-item {
      cursor: pointer;
      
      .nav-link {
        cursor: pointer;
        
        &:hover {
          cursor: pointer;
        }
      }
    }

    .dropdown-item {
      cursor: pointer;
      
      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
